export default __webpack_public_path__ + "static/media/i020hp.89aa17b2.webp";